import { render } from "./KioskPreRegPostView.vue?vue&type=template&id=028fee7c"
import script from "./KioskPreRegPostView.vue?vue&type=script&lang=js"
export * from "./KioskPreRegPostView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__